<router-outlet name="header" />

<rs-alerts class="fixed" />
<router-outlet />

<router-outlet name="footer" />

<rs-load-indicator [iconStyle]="'cube'" />
